<template>
  <dialog
    v-if="show"
    open
    class="tw-fixed tw-inset-0 tw-z-[9999] tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center tw-bg-black/60 tw-backdrop-blur-lg"
  >
    <div class="tw-flex tw-max-w-5xl tw-flex-col tw-items-center tw-gap-5 tw-p-3 tw-text-center">
      <Icon name="warning" class="tw-size-12 tw-fill-current tw-text-state-warn lg:tw-size-24" />
      <Heading level="h2" class="tw-text-white/68">
        To use the Control Room, you must be connected to the NATE VPN.<br />
        To obtain a VPN configuration, contact the RoboCam support at
        <Link href="mailto:robocam@slideslive.com" scheme="underline" class="tw-text-white/68"
          >robocam@slideslive.com</Link
        >. <br /><br />
        If problems persist after connecting to the VPN, try using a different web browser (Firefox or Safari).
      </Heading>
      <Button color="semiTransparentWhite" @click="close">Ignore VPN warning</Button>
    </div>
  </dialog>
</template>

<script setup>
import { Button, Heading, Icon, Link } from '@slideslive/fuse-kit/vue';

const show = defineModel();

function close() {
  show.value = false;
}
</script>
